import {
  Briefcase,
  Building,
  ClipboardList,
  FileCheck,
  FilePlus,
  Files,
  FileSearch,
  FileText,
  Folder,
  Handshake,
  Lock,
  type LucideIcon,
  Scale,
  Shield,
  Sparkles,
  UserCheck,
  Users,
} from 'lucide-react';

/**
 * Maps a template's stored `icon` string to a lucide-react icon component.
 * Shared by the New Document dialog and the org templates page.
 */
export const TEMPLATE_ICON_MAP: Record<string, LucideIcon> = {
  FileText,
  Users,
  Lock,
  Shield,
  Sparkles,
  FileCheck,
  FilePlus,
  FileSearch,
  Files,
  Folder,
  Scale,
  Briefcase,
  Building,
  Handshake,
  UserCheck,
  ClipboardList,
};

/** Resolves a template icon name to its component, falling back to FileText. */
export const getTemplateIcon = (icon?: string): LucideIcon =>
  (icon && TEMPLATE_ICON_MAP[icon]) || FileText;
